
      // this file is automatically generated by git.version.ts script
      export const versions = {
        version: '0.0.0',
        revision: '9588365',
        branch: 'testing_dev_466_469_472'
      };